import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

import ScenarioCriterion from './ScenarioCriterion/ScenarioCriterion'
import { getActiveCriteriaCount } from './helpers'
import * as Styles from './styles'

const VisibilityCriteriaScenario = ({ criteria, onToggleCriterion }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  const activeCount = getActiveCriteriaCount(criteria)

  if (criteria.length === 0) return null

  return (
    <Styles.Container>
      <Styles.Intro>
        <Styles.Header>
          <Text type="titleM">{t('Criterios de visibilidad')}</Text>
          <Text type="bodySRegular">{`${activeCount}/${criteria.length}`}</Text>
        </Styles.Header>
        <Text type="bodySRegular" color={theme.colors.text.muted}>
          {t(
            'Estos son los criterios asignados actualmente a los bloques de este layout. Actívalos o desactívalos para simular qué bloques aparecerían bajo cada combinación.'
          )}
        </Text>
      </Styles.Intro>
      <Styles.CriteriaList>
        {criteria.map(criterion => (
          <ScenarioCriterion key={criterion.id} criterion={criterion} onToggle={onToggleCriterion} />
        ))}
      </Styles.CriteriaList>
    </Styles.Container>
  )
}

export default VisibilityCriteriaScenario
